export default "__VITE_PUBLIC_ASSET__72138f50__"